import React                        from 'react';
import classNames                   from 'classnames';

import { Text }                     from '../../atoms/Text/Text';
import { H2 }                       from '../../atoms/Text/Headings';
import { Fa }                       from '../../atoms/Icons/Fa';
import { Pages, Categories }        from '../../constants/Pages';
import { isServer }                 from '../../../utils';
import { CategoryDescriptionBlock } from './CategoryDescriptionBlock';

import styles                       from './CategoryDescription.css';

type CategoryDescriptionProps = {
    Arena5Slug: Pages | Categories;
};

const SCROLL_CATEGORY_DESCRIPTION = '#description';

export class CategoryDescription extends React.PureComponent<CategoryDescriptionProps> {
    state = {
        isOpened: true,
    };

    containerRef = React.createRef<any>();

    onOpenClick = () => this.setState({
        isOpened: !this.state.isOpened,
    })

    componentDidMount() {
        if (isServer) {
            return;
        }

        if (history && history.scrollRestoration) {
            history.scrollRestoration = 'manual';
        }
        if (this.containerRef && this.containerRef.current && location.href.includes(SCROLL_CATEGORY_DESCRIPTION)) {
            window.scrollTo(0, this.containerRef.current.offsetTop);
        }
    }

    render() {
        const { Arena5Slug } = this.props;
        const shouldShowContent =  this.state.isOpened;

        let headerderText = null;
        switch (Arena5Slug) {
            case Categories.Rewards:
                headerderText = 'Get More of that Winning Feeling with AARP Rewards';
                break;
            case Categories.Juegos:
                headerderText = 'Bienvenido a los Juegos AARP en español';
                break;
            case Categories.StayingSharp:
                headerderText = 'Level up your knowledge of AARP® Staying Sharp®';
                break;
            default:
                return null;
         }

        return (
            <div ref = {this.containerRef}>
                <Container data-element-description = "category description">
                    <CategoryDescriptionHeader
                        aria-label = "Open Category Description Button"
                        onClick = {this.onOpenClick}
                    >
                    <Heading>
                        <HeadingText size = {'h2'}>{headerderText}</HeadingText>
                    </Heading>

                    {
                        this.state.isOpened ?
                        (<Text key = "opened" className={styles.openButton}>
                            <Fa className = {styles.openButtonIcon} icon = "angle-up" />
                        </Text>) :
                        (<Text key = "closed" className={styles.openButton}>
                            <Fa className = {styles.openButtonIcon} icon = "angle-down" />
                        </Text>)
                    }

                    </CategoryDescriptionHeader>
                    <DescriptionText visible = {shouldShowContent}>
                        <CategoryDescriptionBlock Arena5Slug = {Arena5Slug}/>
                    </DescriptionText>
                </Container>
            </div>
        );
    }
}

const Container = (props: any) => <div className = {styles.container} {...props} />;
const Heading = (props: any) => <div className = {styles.heading} {...props} />;
const HeadingText = (props: any) => <H2 className = {styles.headingText} {...props} />;
const CategoryDescriptionHeader = (props: any) => <div className = {styles.categoryDescriptionHeader} {...props} />;
const DescriptionText = (props: any) => (
    <Text
        className = {
            classNames(styles.descriptionText, {
                [styles.visible]: !!props.visible
            })
        }
        {...props}
    />
);
